<p-dialog [(visible)]="changeUserDialog" [style]="{width: '450px'}" header="Change Username" [modal]="true"
    styleClass="p-fluid">

    <ng-template pTemplate="content">
        <form #changeUserForm="ngForm" (ngSubmit)="saveUser()">
            <div class="p-field">
                <label for="newuser">New Username</label><span class="p-pl-1 p-error">*</span>
                <input type="text" pInputText id="newuser" #newuser="ngModel" [(ngModel)]="changeUsername" required
                    name="newuser" class="p-col-6 controls" (blur)="onChangeInput()" (change)="onChangeInput()"
                    (keypress)="onChangeInput()" (keydown)="onChangeInput()" (focusout)="Validateusername()"
                    minlength="4">
                <small
                    *ngIf="(newuser.touched || newuser.dirty || changeUserForm.submitted) && newuser.errors?.required"
                    class="p-error">New
                    Username is
                    required.</small>
                <small
                    *ngIf="changeUserForm.submitted && newuser.errors?.minlength"
                    class="p-error">Name must be at least 4 characters long.</small>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text parent-custom-button "
                        type="submit" [disabled]="!changeUserForm.form.valid || !allowSave"></button>
                    <button pButton pRipple label="Cancel" icon="pi pi-times"
                        class="p-button-text parent-custom-button  p-button-danger" type="button"
                        (click)="hideDialog()"></button>
                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>